import React from "react";
import { publicMainHeaderOffsetClass, PUBLIC_HEADING_TO_CONTENT_CLASS } from "../../../sections/Public/shared/publicLayoutSpec";

const ServiceDetailsSkeleton = () => {
  return (
    <div className="">
      <div className={`tp-container-small mx-auto ${publicMainHeaderOffsetClass()}`}>
        {/* Title skeleton */}
        <div className="w-full mb-8">
          <div className="w-1/3 h-8 animate-pulse bg-gray-200 rounded"></div>
        </div>
        {/* Profile and button row */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-2">
            <div className="rounded-full bg-gray-200 animate-pulse" style={{ width: '48px', height: '48px' }}></div>
            <div className="w-32 h-6 bg-gray-200 animate-pulse rounded"></div>
          </div>
          <div className="w-24 h-8 bg-gray-200 animate-pulse rounded"></div>
        </div>
        {/* Main image/gallery skeleton */}
        <div className="relative flex justify-center items-start">
          <div className="w-full aspect-[4/3] rounded-[8px] bg-gray-200 animate-pulse"></div>
        </div>
        {/* Description skeleton */}
        <div className={`flex flex-col items-center ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
          <div className="max-w-3xl w-full space-y-3">
            <div className="w-full h-4 animate-pulse bg-gray-200 rounded"></div>
            <div className="w-full h-4 animate-pulse bg-gray-200 rounded"></div>
            <div className="w-3/4 h-4 animate-pulse bg-gray-200 rounded"></div>
            <div className="w-1/2 h-4 animate-pulse bg-gray-200 rounded"></div>
          </div>
        </div>
        {/* Centered profile section */}
        <div className={`flex flex-col items-center gap-2 mb-10 ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
          <div className="rounded-full bg-gray-200 animate-pulse" style={{ width: '72px', height: '72px' }}></div>
          <div className="w-32 h-6 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-24 h-8 bg-gray-200 animate-pulse rounded mt-4"></div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailsSkeleton; 